import { useAuth0 } from '@auth0/auth0-react';
import { ContentBlock, Divider, Heading, Loader } from 'braid-design-system';
import { format } from 'date-fns';
import { useMemo } from 'react';

import { PageWrapper } from 'src/components/PageWrapper/PageWrapper';

import { SecurityBreachForm } from './components/SecurityBreachForm/SecurityBreachForm';

export const DATE_FORMAT = "yyyy-MM-dd'T'HH:mm:ss";

export const PRODUCTS = [
  'Job posting',
  'SEEK Optimised Apply',
  'Apply with SEEK',
  'Partner system',
  'Other',
];

export type Product =
  | 'Job posting'
  | 'SEEK Optimised Apply'
  | 'Apply with SEEK'
  | 'Partner system'
  | 'Other';

export interface FormValues {
  dataType: string;
  usersImpacted: string;
  startDate: string;
  actionTaken: 'Yes' | 'No';
  actions: string;
  productsImpacted: Product[];
  otherProduct: string;
  extraDetails: string;
  seekData: 'Yes' | 'No';
  seekCredentials: 'Yes' | 'No';
  seekFault: 'Yes' | 'No';
  partnerName: string;
  contactName: string;
  contactEmail: string;
  contactPhone: string;
  contactHours: string;
}

const SecurityBreach = () => {
  const { user, isLoading } = useAuth0();

  const initialValues = useMemo(
    (): FormValues => ({
      dataType: '',
      usersImpacted: '',
      startDate: format(new Date().setHours(0, 0, 0, 0), DATE_FORMAT),
      actionTaken: 'No',
      actions: '',
      productsImpacted: [],
      otherProduct: '',
      extraDetails: '',
      seekData: 'No',
      seekCredentials: 'No',
      seekFault: 'No',
      partnerName: '',
      contactName: user?.name ?? '',
      contactEmail: user?.email ?? '',
      contactPhone: '',
      contactHours: '',
    }),
    [user],
  );
  const loggedInUser = useMemo(() => user, [user]);

  return (
    <PageWrapper
      heading={
        <Heading level="2" weight="weak">
          Report a Security Breach
        </Heading>
      }
    >
      <ContentBlock align="left">
        <Divider weight="regular" />
      </ContentBlock>
      {isLoading ? (
        <Loader />
      ) : (
        <ContentBlock align="left">
          <SecurityBreachForm
            defaultValues={initialValues}
            user={loggedInUser}
          />
        </ContentBlock>
      )}
    </PageWrapper>
  );
};

export default SecurityBreach;
